export default "__VITE_ASSET__TJ5a$wSo__"